<div class="decline-dialog">
  <div class="decline-dialog__header flex justify-end">
    <button type="button" (click)="close()" class="!rounded-full" aria-label="Close dialog">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle opacity="0.05" cx="20" cy="20" r="20" fill="#E71D36" />
        <path opacity="0.8"
          d="M20.9161 19.9999L24.8099 23.8939C25.0634 24.1472 25.0634 24.5567 24.8099 24.81C24.5567 25.0633 24.1471 25.0633 23.8939 24.81L19.9999 20.916L16.1061 24.81C15.8527 25.0633 15.4433 25.0633 15.1901 24.81C14.9366 24.5567 14.9366 24.1472 15.1901 23.8939L19.0839 19.9999L15.1901 16.1059C14.9366 15.8526 14.9366 15.4431 15.1901 15.1898C15.3163 15.0635 15.4822 15 15.6481 15C15.8139 15 15.9798 15.0635 16.1061 15.1898L19.9999 19.0838L23.8939 15.1898C24.0202 15.0635 24.1861 15 24.3519 15C24.5178 15 24.6836 15.0635 24.8099 15.1898C25.0634 15.4431 25.0634 15.8526 24.8099 16.1059L20.9161 19.9999Z"
          fill="#E71D36" />
      </svg>
    </button>
  </div>
  <div class="decline-dialog__body">
    <div class="flex flex-col mb-3">
      <label class="text-xl font-semibold text-gray-700" for="description">Kindly Input your comments </label>

      <!-- Textarea -->
      <textarea id="description" rows="6" placeholder="Input comments here" [formControl]="merchantComment"
        class="w-full resize-none rounded-lg border border-gray-200 p-4 text-sm text-gray-700 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-100"></textarea>

      @if (((merchantComment.touched || merchantComment.dirty) && merchantComment.invalid)) {
      <p class="text-red-500 text-xs mt-1">
        Comment is required
      </p>
      }

      <app-upload-card class="mt-3" label="Attach Proof" [secondaryLabel]="'(Image/PDF)'"
        (fileChange)="onUploadProof($event)"></app-upload-card>
      @if (((proofFileUrl.touched || proofFileUrl.dirty) && proofFileUrl.invalid)) {
      <p class="text-red-500 text-xs mt-1">
        Kindly upload a proof for service rendered
      </p>
      }
    </div>
  </div>

  <div class="decline-dialog__footer flex justify-end">
    <app-button [inputClass]="'!rounded-lg !px-6 !py-2'" (buttonClick)="onSubmit()">
      Submit
    </app-button>
  </div>
</div>